<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 86 86"
        fill="none"
        width="86"
        height="86"
        class="opacity-50 transition-all duration-300">
        <rect
            rx="43"
            fill="white"
            width="86"
            height="86" />
        <path
            d="M62.1113 43.0003L29.6224 61.1558L29.6224 24.8447L62.1113 43.0003Z"
            fill="currentColor"
            class="transition-colors duration-300" />
    </svg>
</template>

<script setup lang="ts"></script>
